export default {
  GET_ALL: `#graphql
  query getLocations($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getLocations(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        location,
        department,
        availableConveyors,
        availableMethods,
        availableConveyorsCost,
        availableMethodsCost,
        activeBrands,
        activeLocation,
        conveyorCost,
        preferedConveyor
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getLocationsHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getLocationsHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        location,
        department,
        availableConveyors,
        availableMethods,
        availableConveyorsCost,
        availableMethodsCost,
        activeBrands,
        activeLocation
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewLocation($location: LocationInput!) {
    newLocation(input: $location)
    {
      location,
      department,
      availableConveyors,
      availableMethods,
      activeBrands,
        activeLocation
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateLocation($_id: String!, $locationUpdate: LocationUpdateInput!) {
    updateLocation(_id:$_id, locationUpdate: $locationUpdate)
    {
      location
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteLocation($_id: String!) {
    deleteLocation(_id:$_id)
    {
      location
    }            
  }`,

  GET_BY_NAME: `#graphql
  query getLocationsEcommerce($startsWith: String!) {
    getLocationsEcommerce(startsWith: $startsWith)
    { 
      location,
      department
    }            
  }`,

  GET_LOCATIONS_ECOMMERCE_FILTERED: `#graphql
  query getLocationsEcommerceFiltered($find: String!) {
    getLocationsEcommerceFiltered(find: $find)
    { 
      location,
      department
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/location.js